module.exports = __webpack_public_path__ + "static/media/quarrytruck1.5f80cadc.jpg";